var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHarvest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9168 4.72276L13.8153 0.353103C13.7113 0.132414 13.5033 0 13.2536 0H2.72562C2.49675 0 2.26788 0.132414 2.16385 0.353103L0.0624186 4.72276C0.0208061 4.81103 0 4.92138 0 5.03172V15.3379C0 15.7131 0.270481 16 0.624187 16H15.3758C15.7295 16 16 15.7131 16 15.3379V5.03172C15.9792 4.92138 15.9584 4.81103 15.9168 4.72276ZM14.3355 4.36966H8.61378V1.32414H12.8791L14.3355 4.36966ZM3.10013 1.32414H7.36541V4.36966H1.64369L3.10013 1.32414ZM14.7308 14.6538H9.02991V12.5352H6.94929V14.6538H1.24837V5.69379H14.7516V14.6538H14.7308Z",
    fill: "#002C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarvest);
export default __webpack_public_path__ + "static/media/harvest.b3551ba860a53ceb9a1bdb551472a160.svg";
export { ForwardRef as ReactComponent };